function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef, useCallback } from "react";
import classNames from "classnames";
import { TEXT_TYPES, Text } from "#library/components/Text/Text";
import { Link } from "#library/components/Link";
import styles from "./Readmore.module.css";
export var ReadMore = function ReadMore(_ref) {
  var _classNames;
  var readMoreText = _ref.readMoreText,
    _ref$lineLimit = _ref.lineLimit,
    lineLimit = _ref$lineLimit === void 0 ? 3 : _ref$lineLimit,
    children = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? TEXT_TYPES.NORMAL : _ref$type,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return null;
    } : _ref$onClick;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasUserInteracted = _useState4[0],
    setHasUserInteracted = _useState4[1];
  var clampedTextRef = useRef(null);
  var handleClick = useCallback(function () {
    setIsExpanded(true);
    setHasUserInteracted(true);
    onClick();
  }, [onClick]);
  var handleKeyDown = useCallback(function (event) {
    if (event.nativeEvent.code === "Enter") {
      setIsExpanded(true);
      setHasUserInteracted(true);
    }
  }, []);
  useEffect(function () {
    var clampedText = clampedTextRef === null || clampedTextRef === void 0 ? void 0 : clampedTextRef.current;
    if (!clampedText) return function () {
      return null;
    };
    var useMaxHeightClamp = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (useMaxHeightClamp) {
      clampedText.classList.add(styles["jds-ReadMore__truncatedText--max-height"]);
    }
    if (!hasUserInteracted) {
      var isExpandedCalc = clampedText.scrollHeight <= clampedText.clientHeight;
      setIsExpanded(isExpandedCalc);
    }
    var observer = new ResizeObserver(function () {
      if (!hasUserInteracted) {
        var _isExpandedCalc = clampedText.scrollHeight <= clampedText.clientHeight;
        setIsExpanded(_isExpandedCalc);
      }
    });
    observer.observe(clampedText);
    return function () {
      observer.disconnect();
    };
  }, [hasUserInteracted]);
  var containerClassNames = classNames((_classNames = {}, _defineProperty(_classNames, styles["jds-ReadMore__truncatedText--expanded"], hasUserInteracted), _defineProperty(_classNames, styles["jds-ReadMore__truncatedText"], !hasUserInteracted), _classNames));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: clampedTextRef,
    className: containerClassNames,
    style: {
      "--lineNumber": lineLimit
    }
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "div",
    type: type,
    resetSpacing: true
  }, children)), !isExpanded && /*#__PURE__*/React.createElement(Link, {
    isButton: true,
    onKeyDown: handleKeyDown,
    onClick: handleClick,
    className: styles["jds-ReadMore__link"],
    minor: type === "small"
  }, readMoreText));
};